// Transient toast notifications, shown for pushed worker events and user actions.

import $ from 'jquery';
import { esc } from './dom';

type ToastKind = 'info' | 'success' | 'error';

let containerReady = false;
function ensureContainer(): JQuery {
  let $c = $('#toasts');
  if (!containerReady || $c.length === 0) {
    $('#device-frame').append('<div id="toasts" class="toasts"></div>');
    $c = $('#toasts');
    containerReady = true;
  }
  return $c;
}

export function toast(message: string, kind: ToastKind = 'info'): void {
  const $c = ensureContainer();
  const $t = $(`<div class="toast toast--${kind}">${esc(message)}</div>`);
  $c.append($t);
  // enter
  requestAnimationFrame(() => $t.addClass('is-in'));
  // exit
  setTimeout(() => {
    $t.removeClass('is-in');
    setTimeout(() => $t.remove(), 250);
  }, 3200);
}
